module.exports = "img/1.542c96.webp";